import * as React from "react";

import { groupBy } from "lodash";

import moment = require("moment");

import {
    Appointment as AppointmentModel, Direction, AppointmentAndParent,
    getAppointmentsAndEmptySlots, ChildAppointment as ChildAppointmentModel, Clinic
} from "./models";
import { Appointment } from "./Appointment";

interface Props {
    appointment: AppointmentModel | Partial<ChildAppointmentModel>;
    hourSize: number;
    level?: number;
    parentId?: string;
    parentStart?: moment.Moment;
    parentEnd?: moment.Moment;
    timeDirection: Direction;
    onDrop?: (itemId: string, appointment: AppointmentAndParent) => void;
    onClick?: (appointment: AppointmentModel) => void;
}

const AppointmentDetails: React.FunctionComponent<Props> = props => {

    // We should use type narrowing here really to avoid this cast.
    const childAppointments = getAppointmentsAndEmptySlots(props.appointment as AppointmentModel);
    const groupedAppointments = groupBy(childAppointments.filter(c => c.baseAppointmentId), appointment => appointment.baseAppointmentId);

    const appointmentGroups = () => {
        return (Object.keys(groupedAppointments) as (keyof typeof groupedAppointments)[]).map(appointmentKey => {
            const appointments = groupedAppointments[appointmentKey];
            const baseAppointmentIndex = appointments.findIndex(app => app.baseAppointment === true);

            if (baseAppointmentIndex < 0) {
                return React.Fragment;
            }

            return (
                <Appointment
                    appointment={appointments[baseAppointmentIndex]}
                    // We should use type narrowing here really to avoid these casts.
                    mergedAppointments={appointments as AppointmentModel[]}
                    parentAppointment={props.appointment as Clinic}
                    hourSize={props.hourSize}
                    key={appointments[baseAppointmentIndex].start.valueOf()}
                    level={props.level + 1}
                    parentStart={props.parentStart}
                    parentEnd={props.parentEnd}
                    timeDirection={props.timeDirection}
                    isEmpty={appointments[baseAppointmentIndex].emptySlot}
                    onClick={props.onClick}
                    onDrop={props.onDrop}
                />);
        }).concat(standaloneAppointments());
    };

    const standaloneAppointments = () => {
        return childAppointments.filter(c => !c.baseAppointmentId).map(appointment => {
            return (
                <Appointment
                    appointment={appointment}
                    // We should use type narrowing here really to avoid this casts.
                    // i.e. if the appointment is not a clinic appointment then should something else be returned?
                    parentAppointment={props.appointment as Clinic}
                    hourSize={props.hourSize}
                    key={appointment.start.valueOf()}
                    level={props.level + 1}
                    parentStart={props.parentStart}
                    parentEnd={props.parentEnd}
                    timeDirection={props.timeDirection}
                    isEmpty={appointment.emptySlot}
                    onClick={props.onClick}
                    onDrop={props.onDrop}
                />);
        });
    };

    if ((props.appointment.appointments && childAppointments.length === 0) || childAppointments.some(a => !a.start && !a.end)) {
        if (!props.appointment.clinicLocationTypes) {
            return <div />;
        }
        return (
            <div key="clinic description">
                {`${props.appointment.clinicLocationTypes.join(", ")} Clinic - `.trimLeft()}
                {props.appointment.clinicLocationTypes && childAppointments.length} Employee{childAppointments.length === 1 ? "" : "s"}
            </div>
        );
    } else {
        return (<>{appointmentGroups()}</>);
    }
};

export { AppointmentDetails };
